import React, {useState, useEffect} from 'react';
import {withRouter, useHistory, useParams} from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';


//hooks
import useApi from '../../Hooks/useApi';

// styles
import './SalesOrderCreator.css';

// custom components
import SalesOrderCreatorPartTwo from '../../Components/SalesOrderCreatorPartTwo/SalesOrderCreatorPartTwo';

//npm components
import {Img} from 'react-image';

//utilities
import { displayDate } from '../../Utils/dateFormatUtils';
import { displayQuoteNumber } from '../../Utils/displayQuoteNumber';


//carbon components
import {
  Icon,
  Button,
  TextInput,
  DatePicker,
  DatePickerInput,
  FormItem,
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
  OverflowMenu,
  OverflowMenuItem,
  Modal,
  Loading
 } from 'carbon-components-react';
 import { settings } from 'carbon-components';

 import { TrashCan20, Undo20, Add32, RotateClockwise20, ArrowRight20, ZoomIn20 } from '@carbon/icons-react';

 const { prefix } = settings;

 // COMPONENT FUNCTION
 function SalesOrderCreator(props) {

  //set history
  const history = useHistory();

  // get important variables from props and params
  const { id } = useParams();
  const {token, user, salesOrderToEdit, setSalesOrderToEdit} = props;

  //set state
  const [refresh, setRefresh] = useState(false);
  const [currentQuoteItems, setCurrentQuoteItems] = useState([]);
  const [addFlipItemOpen, setAddFlipItemOpen] = useState(false)
  const [step2, setStep2] = useState(0)
  const [newFlip, setNewFlip] = useState({
    itemNumber: "",
    upc: "",
    description: "",
    estimatedShipDate: "",
    packSize: "",
    units: "",
    listPrice: "",
    paidFor: "",
    thumbnails: [],
    actions: true
  })
  const [editItemOpen, setEditItemOpen] = useState(false);
  const [itemEdit, setItemEdit] = useState({});
  const [imagesModalOpen, setImagesModalOpen] = useState(false);
  const [imagesModalUpc, setImagesModalUpc] = useState(null);
  const [quantityModalOpen, setQuantityModalOpen] = useState(false);
  const [quantityModalValue, setQuantityModalValue] = useState(0);
  const [contactInfo, setContactInfo] = useState({
    from: {},
    to: {}
  });

  // custom hooks

  const uid = () => {
    const newUid = uuidv4()
    // console.log("uid created", newUid);
    return newUid
  }

  //componentdid??
  useEffect(( ) => {

    console.log("SALESORDERTOEDIT", salesOrderToEdit);

    if (!salesOrderToEdit) {
      console.error("salesOrderToEdit", "non-existent", salesOrderToEdit)
    }

    if (salesOrderToEdit) {
      console.log("quote exists! yay!!");
      setCurrentQuoteItems(salesOrderToEdit.items)
    }

    return () => {

    };
  }, [])

  //resets the modal quantity number
  useEffect(( ) => {

    // console.log("TRUGGERR", quantityModalValue);

    //resets the modal quantity number
    if (quantityModalOpen === false) {
      setQuantityModalValue("");
    }

    return () => {
    };
  }, [quantityModalOpen])

  // delete an item
  const _handleDeleteQuoteItem = (deleteIndex) => {
    console.log(deleteIndex);
    console.log("deleting", currentQuoteItems[deleteIndex]);

    let confirmed = window.confirm(`Are you sure you want to delete this item?`)
    if (confirmed === false ) return

    let currentQuoteClone = currentQuoteItems.map( (x) => x)
    currentQuoteClone.splice(deleteIndex, 1);
    setCurrentQuoteItems(currentQuoteClone);
  }

  //method that allows user to add a flip item to the quote creator
  const _handleSubmitFlipItems = () => {
    console.log("YAMAN", newFlip);
    let newFlipClone = {};
    newFlipClone = newFlip;

    // processing
    newFlipClone.id = `FLIP${currentQuoteItems.length + 1}`
    newFlipClone.itemNumber  = `FLIP${currentQuoteItems.length + 1}`
    newFlipClone.actions = true;
    let flipDate = new Date(newFlipClone.estimatedShipDate)
    newFlipClone.estimatedShipDate = Date.parse(flipDate)

    let currentQuoteClone = currentQuoteItems;
    currentQuoteClone.push(newFlipClone)
    setCurrentQuoteItems(currentQuoteClone)
    setAddFlipItemOpen(false)
  }

  // setting edit object and opening modal
  const _handleOpenEditModal = (quoteItemIndex) => {
    console.log("editing", quoteItemIndex, currentQuoteItems[quoteItemIndex]);
    setItemEdit(currentQuoteItems[quoteItemIndex])
    setEditItemOpen(true)
  }

  // method to finalize edits to an item
  const _handleEditItem = () => {
    console.log("finalize edits to", itemEdit)
    let itemEditClone = {...itemEdit};
    let currentQuoteClone = [];
    let theIndex;
    currentQuoteClone = currentQuoteItems.map( (quoteItem, i) => {
      if (quoteItem.itemNumber === itemEdit.itemNumber) {
        theIndex = i;
      }
      return quoteItem;
    })
    console.log("EDIT ITEM", currentQuoteItems[theIndex]);
    itemEditClone.id = currentQuoteItems[theIndex].id
    itemEditClone.thumbnail = true;
    itemEditClone.actions = true;
    currentQuoteClone.splice(theIndex, 1, itemEditClone)
    // currentQuoteClone.push(itemEditClone)
    setCurrentQuoteItems(currentQuoteClone);
    setEditItemOpen(false);
  }

  //method that allows user to go back to the previous screen
  const _handleAddMoreInventory = () => {
    let salesOrderToEditClone = {...salesOrderToEdit}
    salesOrderToEditClone.items = currentQuoteItems;
    setSalesOrderToEdit(salesOrderToEditClone);
    history.push('/?mode=edit')
  }

  //method that allows you to open the modal to edit the quantity of a product
  const _handleOpenQtyModal = (quoteItemIndex) => {
    let currentQty = currentQuoteItems[quoteItemIndex].quantity
    console.log(currentQty);
    if (currentQty) {
      setQuantityModalValue(currentQty)
    } else {
      setQuantityModalValue("")
    }
    setItemEdit(currentQuoteItems[quoteItemIndex])
    setQuantityModalOpen(true)
  }

  //method to update the quantity of an item
  const _handleSaveQtyModal = () => {
    let itemClone = {...itemEdit}
    itemClone.quantity = quantityModalValue;

    let itemsClones = currentQuoteItems.map( (item) => {

      if (item.itemNumber === itemEdit.itemNumber) {
        console.log("Editing qty of", item, itemEdit);
        let itemClone = {...item};
        itemClone.quantity = quantityModalValue;
        return itemClone;
      }

      return item

    } )

    setCurrentQuoteItems(itemsClones)
    setQuantityModalOpen(false)
  }

  //asd
  const _handleSetStep2 = () => {
    let noQtyFlag = false;
    currentQuoteItems.map( (item) => {
        if (!item.quantity) {
          noQtyFlag = true;
        }
    })

    if (noQtyFlag) {
      alert("Please make sure you fill out all the quantities before proceeding");
      // return
    }

    setStep2(1)
  }

  // Inventory items selected
  const headers = [
    {
      key: "thumbnail",
      header: ""
    },
    {
      key: 'itemNumber',
      header: 'Item Number'
    },
    {
      key: 'upc',
      header: 'UPC'
    },
    {
      key: "description",
      header: "Description"
    },
    {
      key: "units",
      header: "Units"
    },
    {
      key: "packSize",
      header: "Packet Size"
    },
    {
      key: "listPrice",
      header: "Price"
    },
    {
      key: "quantity",
      header: "Quantity"
    },
    {
      key: "sellUOM",
      header: "UM"
    },
    {
      key: "amount",
      header: "Amount"
    },
    {
      key: "actionsMenu",
      header: "Actions"
    }
  ]

  // Renders

  if (step2 === 1) {
    return (
      <SalesOrderCreatorPartTwo user={user} token={token} setStep2={setStep2} step2={step2} salesOrderToEdit={salesOrderToEdit} setSalesOrderToEdit={setSalesOrderToEdit} currentQuoteItems={currentQuoteItems} />
    )
  }

  if (!salesOrderToEdit) {
    history.push('/quote-database')
    return (
      <div id="homeContainer">
        <span>There is no sales order loaded in memory, please go back to <a href="/quote-database">the quotes database</a> and create a sales order from there</span>
      </div>
    )
  }

  console.log(2, currentQuoteItems);

  return (
    <div id="homeContainer">
      <h3 id="mainTitle">Quote #{displayQuoteNumber(salesOrderToEdit.quoteNumber)} &rarr; Sales Order</h3>

      <div id="actionBtnsContainer">
        <div id="leftActionBtns">
          <Button id="addInventoryBtn" onClick={() => _handleAddMoreInventory()} renderIcon={Add32}>Add Inventory Item</Button>

          <Button id="addFlipItemBtn" onClick={() => setAddFlipItemOpen(true)} renderIcon={RotateClockwise20}>Add Flip Item</Button>


          { /* manage add flip item modal */}


          <Modal
              id="quickAddFlipItem"
              aria-label={"Add flip item modal"}
              open={addFlipItemOpen}
              onRequestClose={() => setAddFlipItemOpen(false)}
              size={"sm"}
              hasScrollingContent={true}
              primaryButtonText={"Add Flip Item"}
              secondaryButtonText={"Cancel"}
              onRequestSubmit={() => _handleSubmitFlipItems()}
            >
            <div id="flipItemModalCont">
              <TextInput
                id="case-code-field"
                labelText="Item Number"
                value={`FLIP${currentQuoteItems.length + 1}`}
                disabled
                style={{ marginBottom: '1rem' }}
              />
              <TextInput
                id="upc-field"
                labelText="UPC"
                placeholder="037000816225"
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setNewFlip({...newFlip, upc: e.target.value})}
              />
              <TextInput
                id="description-field"
                labelText="Description"
                placeholder="CASC GEL ADV PWR FRESH 4/125OZ"
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setNewFlip({...newFlip, description: e.target.value})}
              />
              <TextInput
                id="pd-field"
                labelText="Status"
                placeholder="W"
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setNewFlip({...newFlip, paidFor: e.target.value})}
              />
              <TextInput
                id="units-field"
                labelText="Units"
                placeholder="2000"
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setNewFlip({...newFlip, units: e.target.value})}
              />
              <TextInput
                id="pksize-field"
                labelText="Packet Size"
                placeholder="2000"
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setNewFlip({...newFlip, packSize: e.target.value})}
              />
              <TextInput
                id="price-field"
                labelText="Price"
                placeholder="13.99"
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setNewFlip({...newFlip, listPrice: e.target.value})}
              />
              <TextInput
                id="sellUOM-field"
                labelText="UM"
                placeholder="CS"
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setNewFlip({...newFlip, sellUOM: e.target.value})}
              />
              <DatePicker style={{marginBottom: '1rem'}}
                datePickerType="single"
                onChange={ (e) => setNewFlip({...newFlip, estimatedShipDate:  Date.parse(e) }) }
                >
                <DatePickerInput
                  placeholder="mm/dd/yyyy"
                  labelText="Estimated Shipping Date"
                  id="est-ship-date-field"
                />
              </DatePicker>

            </div>
            </Modal>

            { /* manage edit modal */}

            <Modal
              id="quickEditItem"
              aria-label={"Edit item modal"}
              open={editItemOpen}
              onRequestClose={() => setEditItemOpen(false)}
              size={"xs"}
              hasScrollingContent={true}
              primaryButtonText={"Edit Item"}
              secondaryButtonText={"Cancel"}
              onRequestSubmit={() => _handleEditItem()}
            >
              <TextInput
                id="case-code-field-edititem"
                labelText="Case Code"
                value={itemEdit.itemNumber ? itemEdit.itemNumber : ""}
                style={{ marginBottom: '1rem' }}
                onChange={(e) => setItemEdit({...itemEdit, itemNumber: e.target.value})}
              />
              <TextInput
                id="upc-field-edititem"
                labelText="UPC"
                placeholder="037000816225"
                style={{ marginBottom: '1rem' }}
                value={itemEdit.upc ? itemEdit.upc : ""}
                onChange={(e) => setItemEdit({...itemEdit, upc: e.target.value})}
              />
              <TextInput
                id="description-field-edititem"
                labelText="Description"
                placeholder="CASC GEL ADV PWR FRESH 4/125OZ"
                style={{ marginBottom: '1rem' }}
                value={itemEdit.description ? itemEdit.description : ""}
                onChange={(e) => setItemEdit({...itemEdit, description: e.target.value})}
              />

              <TextInput
                id="pd-field-edititem"
                labelText="PD"
                placeholder="Y"
                style={{ marginBottom: '1rem' }}
                value={itemEdit.paidFor ? itemEdit.paidFor : ""}
                onChange={(e) => setItemEdit({...itemEdit, paidFor: e.target.value})}
              />
              <TextInput
                id="units-field-edititem"
                labelText="Units"
                placeholder="2000"
                style={{ marginBottom: '1rem' }}
                value={itemEdit.units ? itemEdit.units : ""}
                onChange={(e) => setItemEdit({...itemEdit, units: e.target.value})}
              />
              <TextInput
                id="pksize-field-edititem"
                labelText="Packet Size"
                placeholder="2000"
                style={{ marginBottom: '1rem' }}
                value={itemEdit.packSize ? itemEdit.packSize : ""}
                onChange={(e) => setItemEdit({...itemEdit, packSize: e.target.value})}
              />
              <TextInput
                id="price-field-edititem"
                labelText="Price (USD)"
                placeholder="13.99"
                style={{ marginBottom: '1rem' }}
                value={itemEdit.listPrice ? itemEdit.listPrice : ""}
                onChange={(e) => setItemEdit({...itemEdit, listPrice: e.target.value})}
              />
              <TextInput
                id="sellUOM-field-edititem"
                labelText="UM"
                placeholder="CS"
                style={{ marginBottom: '1rem' }}
                value={itemEdit.sellUOM ? itemEdit.sellUOM : ""}
                onChange={(e) => setItemEdit({...itemEdit, sellUOM: e.target.value})}
              />
              <DatePicker style={{marginBottom: '1rem'}}
                datePickerType="single"
                onChange={ (e) => setItemEdit({...itemEdit, estimatedShipDate:  Date.parse(e) }) }
                value={itemEdit.estimatedShipDate ? itemEdit.estimatedShipDate : ""}
                >
                <DatePickerInput
                  placeholder="mm/dd/yyyy"
                  labelText="Estimated Shipping Date"
                  id="est-ship-date-field-edititem"
                />
              </DatePicker>

            </Modal>


              { /* manage Quantity modal */}

              <Modal
                  id="AddQtysItem"
                  aria-label={"Manages item's quantity modal"}
                  open={quantityModalOpen}
                  onRequestClose={() => setQuantityModalOpen(false)}
                  size={"xs"}
                  hasScrollingContent={false}
                  primaryButtonText={"Done"}
                  secondaryButtonText={"Cancel"}
                  onRequestSubmit={() => _handleSaveQtyModal()}
                >

                <TextInput
                  id="pd-field-quantitymodal"
                  labelText="Quantity To Sell"
                  placeholder="12.99"
                  style={{ marginBottom: '1rem' }}
                  value={quantityModalValue}
                  onChange={(e) => setQuantityModalValue(e.target.value)}
                />

                </Modal>

        </div>
        <div id="rightActionBtns">
          <Button onClick={() => _handleSetStep2()} renderIcon={ArrowRight20}>Next</Button>
        </div>
      </div>

      <div id="quoteItemsTableContainer">
        <Table>
          <TableHead>
            <TableRow>
              {headers.map((header) => (
                <TableHeader key={header.key}>{header.header}</TableHeader>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {currentQuoteItems.map((row, quoteItemIndex) => {

              row.thumbnail = true;
              row.actionsMenu = true;
              row.amount = true;

              let sortedRow = {}

              sortedRow.thumbnail = row.thumbnail;
              sortedRow.itemNumber = row.itemNumber;
              sortedRow.upc = row.upc;
              sortedRow.description = row.description;
              sortedRow.units = row.units;
              sortedRow.packSize = row.packSize;
              sortedRow.listPrice = row.listPrice;
              sortedRow.quantity = row.quantity;
              sortedRow.sellUOM = row.sellUOM;
              sortedRow.amount = row.amount;
              sortedRow.actionsMenu = row.actionsMenu;


              // console.log("this row", row);

              return (
              <TableRow key={row.id}>
                {Object.keys(sortedRow)
                  .filter((key) => key !== 'id')
                  .map((key, i) => {
                    // console.log("MAPPING >", key); //// DEBUG:
                    // console.log("OF", row);
                    const headersLabels = headers.map( (header) =>  header.key);

                    if (headersLabels.indexOf(key) < 0) {
                      return
                    }

                    if (key === "thumbnail") {

                      return (
                        <TableCell key={key}>
                          <div id="thumbCellContainer">
                            <a href="#">
                              <Zoom zoomMargin={40}><Img key={i} src={[`https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}.jpg`, `https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}.png`, `https://cwc-product-images-s3-bucket.s3.amazonaws.com/product_images/${row.upc}` , `https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png?format=jpg&quality=90&v=1530129081`]} width={35} /></Zoom>
                            </a>
                          </div>
                        </TableCell>
                      );
                    }

                    if (key === "quantity") {

                      if (!row[key]) {
                        return (
                          <TableCell key={key}><Button id={"openQtyModalBtn"} onClick={() => _handleOpenQtyModal(quoteItemIndex)} size="small">INSERT VALUE</Button></TableCell>
                        )
                      }

                      return (
                        <TableCell key={key}><a id="quantityLinkEdit" onClick={() => _handleOpenQtyModal(quoteItemIndex)} href="#">{row[key]}</a></TableCell>
                      );
                    }

                    if (key === "amount") {

                      if (!row.quantity) {
                        return (
                          <TableCell key={key}>{"—"}</TableCell>
                        )
                      }

                      let listPriceNumber = row.listPrice.replace("$", "");
                      let amountCalc = parseFloat(listPriceNumber) * parseFloat(row.quantity);

                      console.log("DEBUG", 1, row.listPrice, row.quantity, amountCalc);

                      return (
                        <TableCell key={key}>${amountCalc.toFixed(2)}</TableCell>
                      );
                    }

                    if (key === "actionsMenu") {

                      let actionIcon = (
                        <TableCell key="actionsDropdown" className="bx--table-column-menu">
                          <OverflowMenu flipped>
                            <OverflowMenuItem onClick={() => _handleOpenEditModal(quoteItemIndex)} itemText="Modify Item"></OverflowMenuItem>
                            <OverflowMenuItem onClick={() => _handleDeleteQuoteItem(quoteItemIndex)} isDelete itemText="Delete Item"></OverflowMenuItem>
                          </OverflowMenu>
                        </TableCell>
                      )
                      return actionIcon
                    }

                    if (key === "estimatedShipDate") {
                      return (
                        <TableCell key={key}>{displayDate(row[key])}</TableCell>
                      )
                    }

                    if (key === "deleted") {

                      return
                    }

                    if (key === "description" || key === "packSize") {
                      return <TableCell key={key}>{row[key].toUpperCase()}</TableCell>;
                    }

                    return <TableCell key={key}>{row[key]}</TableCell>;
                  })}
              </TableRow>
            )})}
          </TableBody>
        </Table>

      </div>
    </div>

  );
}

export default SalesOrderCreator;
